export function propertyAccessExpression(objectName: string, fieldName: string): string {
  return /^[A-Za-z_$][\w$]*$/.test(fieldName)
    ? `${objectName}?.${fieldName}`
    : `${objectName}?.[${JSON.stringify(fieldName)}]`
}
